var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container-fluid pb-4"},[_c('div',{staticClass:"row"},[_c('nav',{staticClass:"navbar navbar-dark bg-dark navbar-expand-lg navbar-light w-100"},[_c('div',{staticClass:"navbar-brand px-3"},[_c('img',{attrs:{"src":require("@/assets/images/logo-wide-white.png")}})])])])])
}]

export { render, staticRenderFns }